import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chart-area-line', 'ChartAreaLine', [["path",{"d":"M4 19l4 -6l4 2l4 -5l4 4l0 5l-16 0"}],["path",{"d":"M4 12l3 -4l4 2l5 -6l4 4"}]]);